import React from 'react';
import { Plus, RefreshCw } from 'lucide-react';
import { motion } from 'framer-motion';

interface ZonesHeaderProps {
  onRefresh: () => void;
  onAddZone: () => void;
  onBack?: () => void;
  selectedZoneName?: string;
}

const ZonesHeader: React.FC<ZonesHeaderProps> = ({
  onRefresh,
  onAddZone,
  onBack,
  selectedZoneName,
}) => {
  return (
    <div className="flex items-center justify-between">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
      >
        {onBack ? (
          <div className="flex items-center space-x-3 mb-2">
            <button className="inline-flex items-center justify-center px-4 py-2 text-slate-700 bg-white border border-slate-200 hover:bg-slate-50 hover:border-slate-300 focus:ring-2 focus:ring-slate-500 focus:ring-offset-2 font-medium rounded-lg transition-colors focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed" onClick={onBack}>
              ← Back to Zones
            </button>
            <h1 className="text-display-2 text-slate-900 dark:text-white">
              {selectedZoneName || 'DNS Zone'}
            </h1>
          </div>
        ) : (
          <h1 className="text-display-2 text-slate-900 dark:text-white mb-2">DNS Zones</h1>
        )}
        <p className="text-body text-slate-600 dark:text-slate-400">
          Manage your DNS zones and records across all providers
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.2 }}
        className="flex items-center space-x-3"
      >
        <motion.button
          className="inline-flex items-center justify-center px-4 py-2 text-slate-700 bg-white border border-slate-200 hover:bg-slate-50 hover:border-slate-300 focus:ring-2 focus:ring-slate-500 focus:ring-offset-2 font-medium rounded-lg transition-colors focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          onClick={onRefresh}
        >
          <RefreshCw className="w-4 h-4 mr-2" />
          Refresh
        </motion.button>
        <motion.button
          onClick={onAddZone}
          className="inline-flex items-center justify-center px-4 py-2 text-white bg-blue-600 hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 font-medium rounded-lg transition-colors focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          <Plus className="w-4 h-4 mr-2" />
          Add Zone
        </motion.button>
      </motion.div>
    </div>
  );
};

export default ZonesHeader;
